function PayoutMappingService(ApiService) {
    'ngInject';
    const service = {};

    service.getPayoutMappings = function(orgId, url, pageNumber, size, callbackFunc) {
        ApiService.get(url, callbackFunc);
    };

    service.editPayoutMapping = function(mappingFrom, orgId, id, mapingId, callbackFunc) {
        ApiService.put(`/organizations/${orgId}/amazon_payout_mappings/${mapingId}/amazon_payout_mapping_accounts/${id}.json`, mappingFrom, callbackFunc);
    };

    service.deletePayoutMapping = function(orgId, id, mapingId, callbackFunc) {
        ApiService.delete(`/organizations/${orgId}/amazon_payout_mappings/${mapingId}/amazon_payout_mapping_accounts/${id}.json`, {}, callbackFunc);
    };

    service.savePayoutMapping = function(mappingFrom, orgId, mapingId, callbackFunc) {
        ApiService.post(`/organizations/${orgId}/amazon_payout_mappings/${mapingId}/amazon_payout_mapping_accounts.json`, mappingFrom, callbackFunc);
    };

    return service;
}

export default {
    name: 'PayoutMappingService',
    fn: PayoutMappingService
}